class ImageSlider {
    constructor(container, image, handle) {
        this.container = container;
        this.image = image;
        this.handle = handle;

        if (!this.container || !this.image || !this.handle) return;

        this.containerMargin = this.watchContainerMargin();

        // this is necessary to access the 'this' object from the class
        // otherwise 'this' will be overwritten by the eventlistener => this.mouseMoveHandler function undefined
        this.boundMouseMoveHandler = (e) => this.mouseMoveHandler(e);

        this.handle.addEventListener('mousedown', (e) => this.mouseDownHandler(e));
        this.handle.addEventListener('touchstart', (e) => this.mouseDownHandler(e));

        ['mouseup', 'touchend'].forEach((event) => {
            window.addEventListener(event, () => {
                this.container.removeEventListener('mousemove', this.boundMouseMoveHandler);
                this.container.removeEventListener('touchmove', this.boundMouseMoveHandler);
            });
        });
    }

    watchContainerMargin() {
        window.addEventListener('resize', () => {
            this.containerMargin = this.container.getBoundingClientRect().left;
        });
        return this.container.getBoundingClientRect().left;
    }

    mouseDownHandler() {
        this.container.addEventListener('mousemove', this.boundMouseMoveHandler);
        this.container.addEventListener('touchmove', this.boundMouseMoveHandler);
    }

    mouseMoveHandler(e) {
        let moveX = e.pageX ? e.pageX : e.touches[0].pageX;
        if (moveX >= this.container.getBoundingClientRect().right) {
            moveX = this.container.getBoundingClientRect().right;
        }
        this.image.style.width = `${moveX - this.containerMargin}px`;
    }
}

const initImageSliders = (
    imageSliderSelector = '[data-comparison]',
    containerSelector = '[data-comparison-container]',
    imageSelector = '[data-comparison-image]',
    handleSelector = '[data-comparison-handle]'
) => {
    const imageSliders = Array.from(document.querySelectorAll(imageSliderSelector));

    imageSliders.forEach((imageSlider) => {
        new ImageSlider(
            imageSlider.querySelector(containerSelector),
            imageSlider.querySelector(imageSelector),
            imageSlider.querySelector(handleSelector)
        );
    });
};

export { initImageSliders as default };
